module.exports = __webpack_public_path__ + "img/jdm4.c1475eaf.jpg";